"use strict";

import React, {useContext} from 'react';
import AccountPasswordForm from "../../account/component/AccountPasswordForm";
import {useHistory} from "react-router-dom";
import AccountContext from "../context/AccountContext";
import {useAlert} from "react-alert";
import AccountEmailFormBundle from "../../account/component/AccountEmailFormBundle";

const AccountSettingCredentials = (props) => {
    const {
        account={},
        emailIsUnique=()=>{},
        updateAccountEmail=()=>{},
        updateAccountPassword=()=>{},
    } = useContext( AccountContext );
    const history = useHistory();
    const alert = useAlert();
    const emailAddress = account?.user?.email || '';

    function handleAddressFormCancel(e={},){
        e.preventDefault();
        history.push('/echeck/accounts/settings/');
    }

    function handleEmailFormSubmit(data={}){
        updateAccountEmail(data.email||'');
    }

    function handlePasswordFormSubmit(data={}){
        return new Promise((resolve, reject) => {
            updateAccountPassword({...data, email: emailAddress}).finally(()=>{
                resolve();
            });
        });
    }

    return (
        <div>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center',}}>
                <h3>Security Settings</h3>
                <a href="#" title="" className="btn__delete btn__delete--medium"
                   style={{display: 'inline-block',}}
                   onClick={handleAddressFormCancel} />
            </div>
            {!!emailAddress &&
                <AccountEmailFormBundle email={emailAddress} emailIsUnique={emailIsUnique} onSubmit={handleEmailFormSubmit}  />
            }
            <AccountPasswordForm data={{}} onSubmit={handlePasswordFormSubmit}  />
        </div>
    );
};

export default AccountSettingCredentials;
